import React, { useEffect, useState } from 'react'
import { Controller, useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { addCaseType } from 'slices/caseTypeSlice';
import { updateCaseType } from 'slices/caseTypeSlice';
import toast from 'react-hot-toast';
import { caseTypeSelector } from 'slices/caseTypeSlice';
import { setError } from 'slices/caseTypeSlice';
import ErrorMessage from 'components/common/ErrorMessage';
import { CustomSwitch } from 'components/common/Switch';
import { SubmitButton } from 'components/common/buttons/SubmitButton';
import { fetchCaseTypes } from 'slices/caseTypeSlice';

const AddCaseTypesForm = ({ item, handleClose, callback, statusPerm }) => {
  const { handleSubmit, formState: { errors }, control, setValue, } = useForm();
  const dispatch = useDispatch();
  const { error, loader } = useSelector(caseTypeSelector);

  useEffect(() => {
    setValue('name', item?.name || '');
    setValue('status', (typeof (item?.status) == "number") ? item?.status : 1)
    return () => {
      dispatch(setError({}))
      setValue("name", "")
      setValue("status", 1)
    }
  }, [item])



  const submitCallback = (status, message) => {
    if (status) {
      callback()
      toast.success(message, {
        className: "successToast",
      })
      dispatch(fetchCaseTypes())
      handleClose()
    }
    else {
      console.log('onSubmit', error)
      toast.error(message,
        {
          className: "errorToast",
        }
      );
    }
  };

  const onSubmit = (data) => {

  dispatch(setError({}))
  if (item?.id) {
    dispatch(updateCaseType(data, item?.id, submitCallback));
  } else {
    dispatch(addCaseType(data, submitCallback));
  }
}
  return (
    <form onSubmit={handleSubmit(onSubmit)}>

      <div className="row-primary">
        <h2>Type name *</h2>

        <Controller
          name="name"
          control={control}
          render={({ field }) => <input className="input-in type_inp" type="text" name='name' placeholder='Type Name' required {...field} />}
        />
      </div>
      
      {statusPerm &&
        <div className="row-primary flex-row align-items-center" style={{ alignItems: "center" }}>
          <h2 className='mt-0'>Status</h2>
          <Controller
            name="status"
            control={control}
            required
            rules={{
              required: true
            }}
            render={({ field }) => (
              <CustomSwitch
                labelText="active"
                checked={field.value == 1 ? true : false}
                handleChange={(checked) => field.onChange(checked ? 1 : 0)}

              />
            )}
          />
        </div>
      }
      {error?.errors?.name?.map((error) => (
        <div style={{ marginBottom: 10 }}>
          <ErrorMessage text={error} />
        </div>
      ))}

      <div className="Form-footer">
        <button type="button" className="Cancle_button" data-bs-dismiss="modal">Cancel</button>
        <SubmitButton
          loader={loader}
          btnText={item?.id ? "Update" : "Create"}
        />
      </div>
    </form>
  )
}

const AddCaseTypes = ({ item, onClose, callback, statusPerm }) => {
  return (
    <div className={`modal fade`} id="exampleModal" tabIndex="-1" aria-labelledby="exampleModalLabel" role="dialog">
      <div className="modal-dialog modal-dialog-centered modal-lg">
        <div className="modal-content full_modal">
          <div className="modal-header header_modal align-items-center">
            <div></div>
            <h5 className="modal-title_u">{item?.id ? "Update" : "Add"} Case Type</h5>
            <button onClick={onClose} type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div className="modal-body modal_form_body">
            <AddCaseTypesForm item={item} handleClose={onClose} callback={callback} statusPerm={statusPerm} />
          </div>
        </div>
      </div>
    </div>
  )
}

export default AddCaseTypes
